module.exports = __webpack_public_path__ + "img/compu-colores-new.7f6e6b12.webp";